import React from 'react'
import { Autocomplete } from '@mui/material'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

import CustomChip from 'components/Shared/Chip'
interface IProps {
  value: string[]
  inputValue: string
  label: string
  handleOnChange: (newOption: any) => void
  handleInputChange: (newInputValue: any) => void
  handleOnBlur: () => void
  chipProps?: any
  limitTags?: number
  helperText?: string
  variant?: 'standard'
  sx?: any
}

const ChipInput = (props: IProps) => {
  const {
    value,
    inputValue,
    handleOnBlur,
    handleOnChange,
    handleInputChange,
    helperText,
    sx,
    label,
    chipProps = {
      color: 'primary',
    },
    limitTags = 2,
    variant = 'standard',
  } = props

  const { t } = useTranslation()

  const onChange = (newOption: any) => {
    handleOnChange(newOption)
  }

  const onBlur = () => {
    handleOnBlur()
  }

  const onInputChange = (newInputValue: string) => {
    handleInputChange(newInputValue)
  }

  const renderTags = (tagValue: string[] = [], getTagProps: any) => {
    return tagValue?.map((option: any, index: number) => (
      <CustomChip
        key={index}
        size="small"
        filterValues={[option]}
        extraProps={{
          ...getTagProps({ index }),
          color: 'primary',
        }}
      />
    ))
  }

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key == 'Enter') {
      const isUnique = value.indexOf(inputValue) > -1

      if (isUnique) {
        handleInputChange('')
      } else handleInputChange(inputValue)
    }
  }

  return (
    <Autocomplete
      multiple
      freeSolo
      open={false}
      limitTags={limitTags}
      options={[]}
      value={value}
      inputValue={inputValue}
      renderTags={renderTags}
      onChange={(_: React.SyntheticEvent, value) => onChange(value)}
      onInputChange={(_: React.SyntheticEvent, newInputValue: string) =>
        onInputChange(newInputValue)
      }
      onBlur={onBlur}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={label}
          helperText={helperText}
          onKeyDown={onKeyDown}
        />
      )}
      clearText={t('common.clear')}
      ChipProps={chipProps}
      sx={sx}
    />
  )
}

export default ChipInput
